$(function() {
	$('.js-form-modal-login').validate({
	    rules: {
	        login: {
	            email: true
	        }
	    },
	    submitHandler: function(form) {
	        Form.ajaxPost(form, function(data) {
	            $('.js-login-error').hide();

	            if (!data.status) {
	                $('.js-login-error')
	                    .text(data.message)
	                    .slideDown();
	            } else {
	                $('.js-login-hide').slideUp(250, function(){
	                    $('.js-login-success').slideDown(250);
	                });

	                setTimeout(function() {
	                    location.reload();
	                }, 3000);
	            }
	        }, 'json');
	    }
	});
});